const PhotoCheckRequest = require('./photo_check_request.js');

const warningTypeName = 'guitars';
const route = 'acoustic';
const responseAttribute = 'acoustic_body';

module.exports = class AcousitcGuitarsPhotoContents {
  static get productTypeUUID() {
    return '3ca3eb03-7eac-477d-b253-15ce603d2550';
  }

  constructor(photo, imageDetectionPath) {
    this.photo = photo;
    this.imageDetectionPath = imageDetectionPath;
  }

  checkPhoto() {
    return new PhotoCheckRequest(
      this.photo, 
      this.imageDetectionPath, 
      route, 
      responseAttribute, 
      warningTypeName).checkPhoto();
  }
};



// WEBPACK FOOTER //
// ./javascripts/components/photos/contents/acoustic_guitars.js